import http from '@/services/BackendService'

// ชั้นเดียวที่รู้ URL + response key ของฟีเจอร์ Latihan Ilmiah (build บน BackendService)
export default {
    // การ์ดเมนูแสดงเมื่อมี registration ที่ไม่ใช่ dibatalkan
    async fetchExists() {
        const { data } = await http.get('latihanIlmiah/exists')
        return data.data.exists
    },

    // registrations ของตัวเอง — ล่าสุดก่อน
    async fetchRegistrations() {
        const { data } = await http.get('latihanIlmiah')
        return data.data
    },

    // รายละเอียด + progress logs + ไฟล์ + status bab
    async fetchRegistration(id) {
        const { data } = await http.get(`latihanIlmiah/${id}`)
        return data.data
    },

    async uploadFile(id, file, note) {
        const payload = new FormData()
        payload.append('file', file)
        if (note) payload.append('note', note)
        const { data } = await http.post(`latihanIlmiah/${id}/files`, payload)
        return data.data
    },

    deleteFile(id, fileId) {
        return http.delete(`latihanIlmiah/${id}/files/${fileId}`)
    },

    // backend proxy-stream ไฟล์ PDF กลับ (blob)
    async downloadFile(id, fileId) {
        const { data } = await http.get(`latihanIlmiah/${id}/files/${fileId}/download`, { responseType: 'blob' })
        return data   // Blob
    },
}
